import styled from "styled-components";
import { BREAK_POINT } from "../constants";
import Slider from "react-slick";
import { handleLink } from "../utils/handleLink";
import { useEffect, useRef } from "react";

const Banner = () => {
  const positionRef = useRef<{ clientX: number }>({ clientX: 0 });

  const sliderSetting = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    swipeToSlide: true,
    swipe: true,
  };

  const handleMouseDown = (e: MouseEvent) => {
    if (positionRef?.current) {
      positionRef.current.clientX = e.clientX;
    }
  };

  const handleClick = (e: MouseEvent) => {
    if (positionRef?.current && positionRef.current.clientX !== e.clientX) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  useEffect(() => {
    const sysEl = document.getElementById("banner");
    if (sysEl) {
      sysEl.addEventListener("mousedown", handleMouseDown);
      sysEl.addEventListener("click", handleClick);
    }
  }, []);

  return (
    <div id="banner">
      <Slider {...sliderSetting}>
        {/* cgv 무드등 */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_cgv.png"
          mobile="/assets/banner_m_cgv.png"
          onClick={() =>
            handleLink(
              "http://www.cgv.co.kr/culture-event/event/detailViewUnited.aspx?seq=41419&menu=001"
            )
          }
        />
        {/* 메가박스 */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_mega.png"
          mobile="/assets/banner_m_mega.png"
          onClick={() =>
            handleLink("https://www.megabox.co.kr/event/detail?eventNo=15910")
          }
        />
        {/* 롯데시네마 */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_lotte.png"
          mobile="/assets/banner_m_lotte.png"
          onClick={() =>
            handleLink("https://www.instagram.com/p/C-JtRsgylnU/?img_index=1")
          }
        />
        {/* cineq */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_cineq.png"
          mobile="/assets/banner_m_cineq.png"
          onClick={() =>
            handleLink(
              "https://www.cineq.co.kr/Event/Info?eventId=3169&eventSort=-1"
            )
          }
        />
        {/* photowidget */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_photowidget.png"
          mobile="/assets/banner_m_photowidget.png"
          onClick={() => handleLink("https://apple.co/3SnouEA")}
        />
        {/* megacoffee */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_megacoffee.png"
          mobile="/assets/banner_m_megacoffee.png"
          onClick={() =>
            handleLink(
              "https://mega-mgccoffee.com/bbs/detail/?bbs_idx=317&bbs_category=3&bbs_detail_category=&bbs_page=1"
            )
          }
        />
        {/* momstouch */}
        <Wrapper
          className="pointer"
          pc="/assets/banner_m_momstouch.png"
          mobile="/assets/banner_momstouch.png"
          onClick={() =>
            handleLink(
              "https://momstouch.co.kr/promotion/view.php?idx=204&pageNo=1&field=&keyword=&v_sect=&s_gubun=&s_level=&s_gender=&s_sect1%20=&s_sect2=&s_order="
            )
          }
        />
      </Slider>
    </div>
  );
};

export default Banner;

const Wrapper = styled.div<{ pc: string; mobile: string }>`
  width: 100%;
  margin-bottom: 162px;
  ${({ pc }) => pc && `background-image: url(${pc});`}
  height: 0;
  padding: 0;
  padding-bottom: 17%;
  background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    margin-bottom: 24px;
  }

  @media only screen and (max-width: ${BREAK_POINT.mobile}) {
    margin-bottom: 24px;
    padding-bottom: 53%;
    ${({ mobile }) => mobile && `background-image: url(${mobile});`}
  }

  &.pointer {
    cursor: pointer;
  }
`;
